
export class VituCommonErrorEntityIdMustBeNumber extends Error {

    constructor() {
        super("Entity id must be a number.");
    }

}
